import React, {useEffect, useState} from 'react'
import "./Comms.scss"
import Intro from "./Intro/Intro";
import Orbit from "./Orbit";
import Interference from "./Interference";
import Simulation from "./Simulation";
import Band from "./Band/Band";
import Header from '../../partials/Header';
import Modal from "../../partials/Modal/SimpleModal/SimpleModal";
import Splash from "./common/Splash"
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';

function CommsPayload({ data, breadcrumbs, goBackToPreviousSegment, onComplete }) {

    const [currentView, setCurrentView] = useState()
    const [showModal, setShowModal] = useState(false);
    const [buttonsState, setButtonState] = useState(()=>[
        { 
            text: data.requirements.button, 
            action: (e)=> handleModal(e, {
                title: data.requirements.button,
                body: data.requirements.content
            }),
            disabled: false
        },
        // { 
        //     text: "Comms Decisions", 
        //     action: (e)=> handleModal(e, {
        //         title: 'Comms Decisions'
        //     }),
        //     className: 'decisions',
        //     disabled: true
        // },
        { 
            text: data.analysis.button, 
            action: (e)=> handleModal(e, {
                title: data.analysis.button,
                body: data.analysis.content
            }),
            className: 'orbit-analysis',
            disabled: true
        },
        { 
            text: data.formulas.button,
            action: (e)=> handleModal(e, {
                title: data.formulas.button,
                body: data.formulas.content

            }),
            className: 'formulas',
            disabled: true,
            hide: true
        }
    ])
    const [bandResponses, setBandResponses] = useState();
    const [orbitResponses, setOrbitResponses] = useState();
    const [linkResponses, setLinkResponses] = useState();


    useEffect(() => {
        if(!currentView) setCurrentView({
            name: 'splash', 
            content: {__html: data.intro},
            buttons: [{ 
                text: "Start", 
                action: (e)=> showOrbitView()
            }]
        })

    }, []) 

    const enableButton = (name, enable, hide) => {
        return buttonsState.map((button)=> {
            if(button.text === name) return { ...button, disabled: !enable, hide: hide }
            return button
        })
    }

    /**
     * handleSelectedBand
     * when a response is confirmed
     * we add the response to the state
     * @param {*} selectedBand 
     */
    const handleSelectedBand = selectedBand => {

        
        const response = {
            questions: [{
                text: "Communications Band", 
                answers: [
                   selectedBand 
                ] 
            }]
        }
        setBandResponses(response)
        setButtonState(enableButton('Comms Decisions', true))
        setCurrentView({
            name: 'splash', 
            header: { 
                title: "", 
                intro: "" 
            },
            content: {__html: data.band.conclusions},
            buttons: [
            { 
                text: "Next", 
                className: "primary side-margins",
                action: (e)=> showOrbitView()
            }]
        })

    }

    const handleCompletedOrbit = (answers) => {        
        setOrbitResponses(answers)
        setButtonState(enableButton(data.analysis.button, true))
        setCurrentView({
            name: 'splash', 
            header: { 
                title: "", 
                intro: "" 
            },
            content: {__html: data.orbit.conclusions},
            buttons: [{ 
                text: "Next", 
                className: "side-margins",
                action: (e)=> showOrbitView()
            },
            { 
                text: "Next", 
                className: "primary side-margins",
                action: (e)=> showInterferenceView()
            }]
        })

    }

    const handleCompletedInterference = (answers) => {
        setButtonState(enableButton('Formulas', true))

        setCurrentView({
            name: 'splash', 
            header: { 
                title: "", 
                intro: "" 
            },
            content: {__html: data.interference.conclusions},
            buttons: [{ 
                text: "Next", 
                className: "side-margins",
                action: (e)=> showInterferenceView()
            }]
        })

    }

    /**
     * showBandView
     */
    const showBandView = () => {
        setCurrentView({
            name: 'band', 
            header: { 
                title: data.band.title, 
                intro: data.band.intro 
            },
            content: data.band
        })
    }
    const showOrbitView = () => {
        setCurrentView({
            name: 'orbit', 
            header: { 
                title: data.orbit.title, 
                intro: data.orbit.description 
            },
            content: data.orbit
        })
    }
    const showInterferenceView = () => {
        setCurrentView({
            name: 'interference', 
            header: { 
                title: data.interference.title, 
                intro: data.interference.description 
            },
            content: data.interference
        })
    }

    /**
     * handleModal
     * opens a shared modal component
     * @param {*} e 
     * @param {*} obj 
     */
    const handleModal = (e, obj) => {
        
        setShowModal({
            title: obj.title,
            body: obj.body
        });


    }
    /**
     * handleModalClose
     * close a shared modal component
     * @param {*} e 
     * @param {*} obj 
     */

    const handleModalClose = (e) =>{
        setShowModal(false);
    }

    
    return <InteractionContainer withFrame={true} breadcrumbs={breadcrumbs}>
        
        {/* Simulation Screen */}
        {currentView && currentView.name =='simulation' &&
            <Simulation data={currentView.data} />
        }
        {/* Shared Header */}

        {/* Main Content */}
        <main className={'comms-content'} >

            {/* Splash content */}
            {currentView && currentView.name === 'splash' && 
                <Splash 
                    content={currentView.content} 
                    buttons={currentView.buttons}    
                    backButtonHandler={goBackToPreviousSegment}
                />
            }

            {/* Band content */}
            {currentView && currentView.name === 'band' && 
                <Band band={data.band} onSelectedBand={handleSelectedBand} />
            }

            {/* Orbit content */}
            {currentView && currentView.name === 'orbit' && 
                <Orbit 
                    data={currentView.content} 
                    buttonsState={buttonsState}
                    updateButtonState={(answers)=>{
                        setOrbitResponses(answers)
                        setButtonState(enableButton(data.analysis.button, true))
                    }}
                    goToPrevious={showOrbitView}
                    onComplete={()=> onComplete()} />
            }

            {/* Interference content */}
            {currentView && currentView.name === 'interference' && 
                <Interference data={currentView.content} onComplete={handleCompletedInterference} />
            }

        </main>

        {/* Shared Modal */}
        <Modal
            size='small'
            show={showModal ? true : false}
            header={showModal ? showModal.title : false}
            html={showModal ? showModal.body : false}
            onClose={handleModalClose} >
                
                {/* Conditional Childrens */}

                {showModal && showModal.title==="Comms Decisions" && bandResponses &&
                    <>
                        {bandResponses.questions.map((question, index) => (
                            <div key={index} className="response-container">
                                <strong>{question.text}:</strong>
                                <div>{ question.answers[0].title }</div>
                            </div>

                        ))}
                    </>
                }

                {showModal && ( showModal.title==="Comms Decisions" || showModal.title==="Orbit Analysis Results") && orbitResponses &&
                    <>
                        {orbitResponses.map((question, index) => (
                            <div key={index} className="response-container">
                                <strong key={index}>{question.label}:</strong>
                                {question.answers.map((answer, index) => (
                                    <div key={`asnwr_${index}`}>{ answer.option }</div>
                                ))}
                            </div>

                        ))}
                    </>
                }

            
        </Modal>
    </InteractionContainer>
}

export default CommsPayload;
